import { useState, memo, useCallback } from 'react';
import './LiveEvent.scss';
import iframeWithWhisper from '../iframe/WhisperIframe';
import Iframe from '../iframe/Iframe';
import ReactPlayer from 'react-player';
import SettingsService from '../../services/SettingsService';
import { getMakeConfig } from '../../utils/models';
import { getDeviceInfo } from '../../Upshow';

// To avoid re-renders when LiveEvent component states/props changes
const MemoizedIframeComponent = memo(
    ({
        src,
        onDone,
        onError,
        onProgress,
        onPlay,
        className,
        disableWatchdog,
    }) => {
        const IframeComponent = iframeWithWhisper(Iframe);    
        return (
            <IframeComponent
              className={className}
              disableWatchdog={disableWatchdog}
              onDone={onDone}
              onError={onError}
              onProgress={onProgress}
              onPlay={onPlay}
              src={src}
            />
        );
    }
);

export default function LiveEvent(props) {
    const [placeholderVideoError, setPlaceholderVideoError] = useState(false);
    const videoLiveEventPlaceholder = getMakeConfig().liveEventState.videoPlaceholder;
    const comingSoonImage = 'https://cdn.upshow.tv/ui-assets/Everpass_Live_Event.jpg';

    // Memoize callbacks to avoid re-renders
    const handleDone = useCallback(() => props.done(), [props.done]);
    const handleError = useCallback((error) => {props.error(error)}, [props.error]);
    const handleProgress = useCallback(() => {
    if (props.playerError) {
        props.solveError();
      }
    }, [props.playerError, props.solveError]);

    if (!props?.state?.liveEvent) return null;

    if (props.state.liveEvent.status === 'COMING') {
        const VideoUrl = 'https://cdn.upshow.tv/ui-assets/Everpass_Live_Event_60s.mp4';
        return <>
            {
                (!placeholderVideoError && videoLiveEventPlaceholder)
                    ? <ReactPlayer
                        width="100%"
                        height="100%"
                        onError={() => setPlaceholderVideoError(true)}
                        playing={true}
                        url={VideoUrl}
                        muted={false}
                        volume={1}
                        key={VideoUrl}
                        loop={true}
                    />
                    : <img width="100%" height="100%" src={comingSoonImage} alt="Event coming soon"/>
            }
        </>;
    } else if (props.state.liveEvent.status === 'LIVE') {
        if (window.UPshowAndroidApp) { //we're in UPshow's android app, let the app take over
            return <img width="100%" height="100%" src={comingSoonImage} alt="Event coming soon" />
        }
        const metadata = props.state.liveEvent.metadata ?? {};
        const token = props.state.liveEvent.token ?? "";

        const url = new URL(metadata.url);
        url.searchParams.set('device_id', props.settings.device_id);
        url.searchParams.set('evid', props.state.liveEvent.id);

        if (token) {
            url.searchParams.set('token', token);
        }

        const withCC = SettingsService.getSetting('withCC');

        if (withCC) {
            url.searchParams.set("withCC", withCC);
        }

         const organizationId = SettingsService.getSetting("organization_id");
         const dataOrganization = SettingsService.getSetting("organization")
         const uiVersion = SettingsService.getSetting("uiVersion")
         
         const playerUrl = new URL(url.toString());
         
         playerUrl.searchParams.set("model", getDeviceInfo()?.model || "");
         
         if (props.state.liveEvent.title) playerUrl.searchParams.set("title", encodeURIComponent(props.state.liveEvent.title));
         if (organizationId) playerUrl.searchParams.set("organization_id", organizationId);
         if (dataOrganization) {
             let value = `${dataOrganization.id} (${dataOrganization.name})`

             playerUrl.searchParams.set("organization", value);
         }

         if (uiVersion && uiVersion !== "") {
            playerUrl.searchParams.set("uiVersion", uiVersion);
         }

        return (
            <>
                <MemoizedIframeComponent
                    className="LiveEvent"
                    disableWatchdog={true}
                    onDone={handleDone}
                    onError={handleError}
                    onProgress={handleProgress}
                    src={playerUrl}
                />
            </>
        );
  }

  return null;
}
